import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours, { isColourName } from '/shared/styled/Colours';

export default function customColourStyle({
  $customColour,
  $customColourHover,
  $outline,
  $primary,
}: ButtonStyleProps) {
  if ($customColour) {
    let colour: string | undefined = $customColour;
    if ($customColour.indexOf('#') < 0 && isColourName($customColour)) {
      colour = Colours[$customColour];
    }
    let colourHover = $customColourHover;
    if ($customColourHover && $customColourHover.indexOf('#') < 0 && isColourName($customColourHover)) {
      colourHover = Colours[$customColourHover];
    }
    if ($outline) {
      return css`
        border-color: ${colour};

        &:hover, &:focus, &:active {
          border-color: ${colourHover};
        }
      `;
    }
    if ($primary) {
      return css`
        background-color: ${colour};

        &:hover, &:focus, &:active {
          background-color: ${colourHover};
        }
      `;
    }
  }
}
